<template>
  <component :is="this.$route.meta.layout || 'div'">
    <router-view/>
  </component>
</template>

<script>
//import { ref, provide, onBeforeMount } from 'vue'
//import { onBeforeRouteUpdate } from "vue-router";
import { useI18n } from 'vue-i18n'
import { loadAllLookups } from '@/common/app_configs';

export default {

  setup() {
    const { t } = useI18n({ useScope: 'global' });

    const confirmUpdateVersion = function(e) {
      console.log("Inside appUpdateUI, new version registered, e.detail ==> ", e.detail);
      if (confirm(t('confirm_update_version'))) {
        const registration = e.detail;
        if (registration || registration.waiting) {
          registration.waiting.postMessage({type:'SKIP_WAITING'});
        }        
      }
    }

    return {
      confirmUpdateVersion
    }
  },
  created() {
    document.addEventListener(
      'serviceWorkerUpdateEvent', this.confirmUpdateVersion //, { once: true }
    );    
  },
  mounted() {
    loadAllLookups();
  }
}
</script>